const _getGiftWrapInfo = state => (state ? state.giftWrap || {} : {});
const getSelectedWrapEntries = state => _getGiftWrapInfo(state).selectedWrapEntries || [];
const getGiftOptionData = state => _getGiftWrapInfo(state).giftOptionData || {};
const getAppliedGiftOptions = state => _getGiftWrapInfo(state).appliedGiftOptions || [];
const getAppliedGiftOption = (state, optionCode) =>
    getAppliedGiftOptions(state).find(item => item.giftOptionCode === optionCode) || {};
const getEmptyErrorMsg = state => _getGiftWrapInfo(state).showEmptyError || false;
const _getGiftWrapMetadata = state => _getGiftWrapInfo(state).metadata || {};
const _getGiftWrapMetadataSteps = state => _getGiftWrapMetadata(state).steps || [];
const _getGiftWrapMetadataStepFields = state =>
    (_getGiftWrapMetadataSteps(state)[0] && _getGiftWrapMetadataSteps(state)[0].fields) || [];

const getFieldConstraints = state => {
    const { constraints = [] } = _getGiftWrapMetadataStepFields(state)[1] || {};
    const patternConstraint = constraints.find(data => data && data.type === 'length');
    return (patternConstraint && patternConstraint.parameters) || {};
};

const getPatternConstraints = state => {
    const { constraints = [] } = _getGiftWrapMetadataStepFields(state)[1] || {};
    const patternConstraint = constraints.find(data => data && data.type === 'pattern');
    return (patternConstraint && patternConstraint.parameters) || {};
};

const getEmptyMsgFeatureFlag = state => _getGiftWrapInfo(state).emptyMsgFeatureFlag;

export default {
    getSelectedWrapEntries,
    getGiftOptionData,
    getAppliedGiftOptions,
    getAppliedGiftOption,
    getFieldConstraints,
    getEmptyErrorMsg,
    getEmptyMsgFeatureFlag,
    getPatternConstraints,
};
